module.exports = __webpack_public_path__ + "static/img/ewm-owner2.618b798.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/ewm-owner2.jpg
// module id = ai53
// module chunks = 1